import { render, staticRenderFns } from "./user-data.vue?vue&type=template&id=dbbfd2d2&scoped=true&"
import script from "./user-data.vue?vue&type=script&lang=js&"
export * from "./user-data.vue?vue&type=script&lang=js&"
import style0 from "./user-data.vue?vue&type=style&index=0&id=dbbfd2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbfd2d2",
  null
  
)

export default component.exports